import { render, staticRenderFns } from "./ClientesAtendidos.vue?vue&type=template&id=2dee8084&"
import script from "./ClientesAtendidos.vue?vue&type=script&lang=js&"
export * from "./ClientesAtendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dee8084')) {
      api.createRecord('2dee8084', component.options)
    } else {
      api.reload('2dee8084', component.options)
    }
    module.hot.accept("./ClientesAtendidos.vue?vue&type=template&id=2dee8084&", function () {
      api.rerender('2dee8084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientesAtendidos.vue"
export default component.exports